module.exports = __webpack_public_path__ + "img/push-puller-3.f6fd826f.svg";